import React from "react";
import { Button } from "./ui/button";
import { Phone, CheckCircle2 } from "lucide-react";
import { COMPANY, STATS } from "../mock";

export default function About({ onBookNow }) {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
        <div className="relative flex items-center justify-center">
          <img
            src="/assets/cheerings-ute.png"
            alt="Cheerings Plumbing Group service ute"
            className="w-full max-w-[640px] lg:max-w-[720px] xl:max-w-[820px] object-contain drop-shadow-2xl rotate-6 select-none"
          />
        </div>

        <div>
          <div className="inline-block px-3 py-1 rounded-full bg-sky-100 text-[#0a4f8a] text-xs font-bold uppercase tracking-wider mb-3">
            About Cheerings
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0a4f8a] mb-5">
            Sydney's Friendly, Five-Star Local Plumbers
          </h2>
          <p className="text-slate-600 mb-6">
            Cheerings Plumbing Group is a family-run team of fully licensed Sydney plumbers
            handling residential, commercial, industrial and renovation work — from leaking taps
            to full bathroom rough-ins. Honest advice, quality workmanship and reliable service
            on every job.
          </p>
          <p className="text-slate-600 mb-6">
            Every ute rolls out fully stocked — CCTV drain cameras, high-pressure jetters, leak
            detection gear and pipe-relining kits — so we finish most jobs on the first visit and
            get you sorted fast.
          </p>

          <ul className="grid sm:grid-cols-2 gap-3 mb-7">
            {[
              "Same-day appointments",
              "Upfront fixed pricing",
              "15+ years experience",
              "All work guaranteed",
            ].map((f) => (
              <li key={f} className="flex items-center gap-2 text-slate-700">
                <CheckCircle2 size={18} className="text-sky-600" />
                <span className="text-sm font-medium">{f}</span>
              </li>
            ))}
          </ul>

          <div className="flex flex-wrap gap-3">
            <Button
              onClick={onBookNow}
              className="bg-sky-600 hover:bg-sky-700 text-white font-bold px-6 py-5"
            >
              Book Appointment
            </Button>
            <a href={`tel:${COMPANY.phoneLink}`}>
              <Button
                variant="outline"
                className="border-[#0a4f8a] text-[#0a4f8a] hover:bg-[#0a4f8a] hover:text-white font-semibold px-6 py-5"
              >
                <Phone size={16} className="mr-2" /> {COMPANY.phone}
              </Button>
            </a>
          </div>

          <div className="grid grid-cols-4 gap-4 mt-10 pt-8 border-t">
            {STATS.map((s) => (
              <div key={s.label}>
                <div className="text-2xl md:text-3xl font-extrabold text-[#0a4f8a]">{s.value}</div>
                <div className="text-xs text-slate-600 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
